import { SlideOver } from '@components/slide-over';
import { Tabs, Tab } from '@components/tabs';
import { StockPhotoPicker } from './stock-photo-picker';
import { filepicker } from '@components/filepicker';
import { showError } from '@components/app-error';

export function PhotoPicker({
  isOpen,
  onPick,
  onClose,
}: {
  isOpen: boolean;
  onPick: (url: string) => void;
  onClose: () => void;
}) {
  async function pickPhoto() {
    try {
      const result = await filepicker({
        accept: 'image/*',
        cropRatio: 1,
        requireCrop: true,
        sources: ['filepicker', 'takephoto'],
      });

      if (result) {
        onPick(result.publicUrl);
      }
    } catch (err) {
      showError(err);
    }
  }

  if (!isOpen) {
    return null;
  }

  return (
    <SlideOver close={onClose} w="max-w-4xl w-screen z-max">
      <div class="flex flex-col h-full">
        <div class="mb-6">
          <h2 class="text-2xl font-bold mb-4">Choose a Photo</h2>
          <Tabs>
            <Tab isSelected>Stock Photos</Tab>
            <Tab isSelected={false} onClick={pickPhoto}>
              Upload Photo
            </Tab>
          </Tabs>
        </div>
        <StockPhotoPicker onPick={(photo) => onPick(photo.url)} />
      </div>
    </SlideOver>
  );
}
